import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-xing_icon",
  "use": "icon-xing_icon-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-xing_icon\"><path d=\"M24 0C10.746 0 0 10.746 0 24C0 37.254 10.746 48 24 48C37.254 48 48 37.254 48 24C48 10.746 37.254 0 24 0ZM12.178 29.992L16.978 21.526L13.75 15.992H19.512L22.714 21.51L17.912 29.992H12.178ZM33.878 38H28.182L21.972 26.722L31.388 10H37.142L27.728 26.722L33.878 38Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol